import { Tag, Text } from '@mercai/clever'
import { AgentNodeProps } from './nodes.type'

import { INodeVisualComponentProps, Port } from 'react-easy-diagram'
import { observer } from 'mobx-react-lite'

import { generateClassess } from './node.constants'

import styles from './node.module.css'

export const Nodes = observer<INodeVisualComponentProps>(({ entity }) => {
  const nodeData = (entity.data as AgentNodeProps) || {}
  const { role, name, type, isActive, uuid, onNodeDoubleClick } = nodeData

  const classess = generateClassess(type, isActive || false, entity.selected)

  const handleClick = () => {
    if (onNodeDoubleClick && uuid) {
      onNodeDoubleClick(uuid)
    }
  }

  return (
    <div className={classess} onDoubleClick={handleClick}>
      <div className={styles.header}>
        <Text variant="title-medium">{name}</Text>
      </div>

      <div className={styles.content}>
        <Text>
          role: <Text variant="title-base">{role}</Text>
        </Text>
        <Text>
          type: <Text variant="title-base">{type}</Text>
        </Text>
        <Tag
          variant={isActive ? 'primary' : 'basic'}
          model="light"
          size="small"
        >
          {isActive ? 'active' : 'inactive'}
        </Tag>
      </div>

      {Array.from(entity.ports).map(([id]) => (
        <Port id={id} key={id} />
      ))}
    </div>
  )
})
